import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PipelineViewComponent } from './pipeline-view.component';

const routes: Routes = [
  {
    path: '',
    component: PipelineViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PipelineViewRoutingModule { }
